import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import {
  ChakraProvider,
  theme,
  Text,
  Flex,
  Input,
  Button,
  Image,
  Tooltip,
} from '@chakra-ui/react';
import Header from '../components/Header';
import CheckImg from '../assets/img/check_circle.svg';
import { Link } from 'react-router-dom';
import {
  getEventDownloadLink,
  requestEventDownloadLink,
} from '../apis/download/index';

const DownloadPhotos = props => {
  const [showToolTipOtp, setShowToolTipOtp] = useState(false);
  const [showToolTipOtp2, setShowToolTipOtp2] = useState(false);
  const [showPhotoLoading, SetGetPhotoLoading] = useState(false);
  const [userDetail, SetUserDetail] = useState(null);
  const [errorMsg, seterrorMsg] = useState('Please Enter Name');
  const [showLoading, SetLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const history = useHistory();
  const [urlData, setUrlData] = useState(null);
  const { slug } = props.match.params;
  const emailRef = useRef();
  const nameRef = useRef();

  useEffect(() => {
    const urlSlug = JSON.parse(decodeURIComponent(slug));
    setUrlData(urlSlug);
    let { api, eventId, userId } = urlSlug;
    getEventDownloadLink(api, eventId, userId).then(response => {
      !response.error
        ? setDownloadUrl(response.download_link)
        : alert(`Error : ${response.message}`);
    });
  }, []);

  const PurchasedBtn = () => {
    let { eventId } = urlData;
    SetLoading(true);
    history.replace(`${process.env.PUBLIC_URL}/showroom/${eventId}`)
    SetLoading(false);
  };

  const GetPhotoBtn = () => {
    let email = emailRef.current.value;
    let name = nameRef.current.value;
    //bharat please add email validatain here
    let { api, eventId, userId } = urlData;
    if (userDetail && email) {
      requestEventDownloadLink(api, eventId, userId, name, email).then(
        response => {
          if (!response.error) {
            alert('You will receive download email shortly.');
            history.replace(`${process.env.PUBLIC_URL}/showroom/${eventId}#purchased`);
          } else {
            alert(`Error : ${response.message}`);
          }
        }
      );
    } else {
      alert('Fill Name and Email fields are mandetory !');
    }
  };

  const handelChange = e => {
    SetUserDetail(e);
  };

  return (
    <React.Fragment>
      <ChakraProvider theme={theme}>
      <Flex className="screen-detect-cntr" justifyContent="center" alignItems="center" flexFlow="column"> 
        <Flex className="screen-detect" flexFlow="column">
        <Flex flexDirection="column" overflow="hidden" bg="#f9f9f9">
          <Header title={'Download Photos'} />

          <Flex flexDirection="column" alignItems="center" mb="40px">
            <Flex flexDirection="row" alignItems="center" mt="10">
              <Text
                textAlign="center"
                fontSize="20px"
                color="#222222"
                fontWeight={700}
              >
               Download Photos
              </Text>
              <Image ml="2" src={CheckImg} alt="Select Img" w="26px" h="26px" />
            </Flex>
{(1!=1?
            <Flex mt="5" flexDirection="column" alignItems="center">
              <Text color="#8d8a8a" fontSize="15px" fontWeight="700">
                Download photos by clicking this link:
              </Text>
              <a href={downloadUrl} target="_blank" style={{ width: '75%' }}>
                <Text
                  fontSize="15px"
                  fontWeight="700"
                  color="#FA2F45"
                  textAlign="center"
                >
                  {downloadUrl}
                </Text>
              </a>
            </Flex>:'')
}
            <Flex
              mt="5"
              bg="white"
              borderRadius="20px"
              p="20px"
              alignItems="center"
              ml="2"
              boxShadow="0px 10px 40px rgba(0, 0, 0, 0.03)"
              mr="2"
              flexDirection="column"
            >
              <Text
                mt="2"
                textAlign="center"
                color="#8d8a8a"
                fontSize="18px"
                fontWeight="700"
              >
                Get photos and download link on email?
              </Text>

              <Input
                ref={nameRef}
                mt="20px"
                type="text"
                height="12"
                fontSize="13px"
                placeholder="Your Name"
                onChange={e => handelChange(e)}
              />
              {showToolTipOtp && (
                <Tooltip
                  label={errorMsg}
                  placement="top"
                  isOpen
                  mt="-70px"
                  ml="12px"
                >
                  {' '}
                </Tooltip>
              )}

              <Input
                type="email"
                ref={emailRef}
                height="12"
                fontSize="13px"
                placeholder="Email address"
                mt="4"
                onChange={e => handelChange(e)}
              />
              {showToolTipOtp2 && (
                <Tooltip
                  label={errorMsg}
                  placement="top"
                  isOpen
                  mt="-70px"
                  ml="12px"
                >
                  {' '}
                </Tooltip>
              )}

              <Button
                w="90%"
                color="#FA2F45"
                bg="white"
                h="12"
                mt="6"
                isLoading={showPhotoLoading}
                loadingText="Get Photos on Email"
                colorScheme="white"
                borderRadius="40"
                fontSize="15px"
                fontWeight="700"
                border="1px solid #FA2F45"
                onClick={() => GetPhotoBtn()}
              >
                Get Photos on Email
              </Button>
            </Flex>
          </Flex>

          <Flex mt="2" w="100%" justifyContent="center" alignItems="center">
              <Button
                color="white"
                pl="10"
                pr="10"
                isLoading={showLoading}
                loadingText="Go to Photo Gallery"
                colorScheme="#FA2F45"
                bg="#FA2F45"
                h="12"
                borderRadius="40"
                onClick={() => PurchasedBtn()}
              >
                Go to Photo Gallery
              </Button>
          </Flex>
        </Flex>
        </Flex>
        </Flex>
      </ChakraProvider>
    </React.Fragment>
  );
};

export default DownloadPhotos;
